const $cloudinaryUrl = {
  methods: {
    $cloudinaryUrl (type, id, transformation, version) {
      try {
        return `https://${process.env.VUE_APP_CLOUDINARY_IMAGES_DOMAIN}/${type}/upload/${transformation ? transformation + '/' : ''}${(version ? `v${version}/` : '')}${id}`
      } catch (err) {
        console.log('cloudinaryUrl mixin error', err)
        return ''
      }
    }
  }
}

export {
  $cloudinaryUrl
}
